import React, { useState, useEffect } from 'react';
import './InstallBanner.css';

const STORAGE_KEY = 'tapes_install_dismissed';

function getInstallState() {
  if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
    return 'installed';
  }
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
  if (/Android/.test(ua)) return 'android';
  return null;
}

function InstallBanner() {
  const [visible, setVisible] = useState(false);
  const [platform, setPlatform] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return;
    const state = getInstallState();
    if (state && state !== 'installed') {
      setPlatform(state);
      setTimeout(() => setVisible(true), 1200);
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem(STORAGE_KEY, '1');
  };

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') dismiss();
      setDeferredPrompt(null);
    } else {
      setExpanded(true);
    }
  };

  if (!visible) return null;

  return (
    <div className={`install-banner ${expanded ? 'install-banner--expanded' : ''}`}>
      <button className="install-banner-close" onClick={dismiss} aria-label="Dismiss">✕</button>

      {!expanded ? (
        <div className="install-banner-row">
          <span className="install-banner-icon">📼</span>
          <div className="install-banner-text">
            <span className="install-banner-title">Get the app</span>
            <span className="install-banner-sub">Save Tapes to your home screen</span>
          </div>
          <button className="install-banner-btn" onClick={handleInstall}>Install</button>
        </div>
      ) : (
        <div className="install-banner-tutorial">
          <div className="install-banner-tutorial-title">Add to Home Screen</div>
          {platform === 'ios' ? (
            <ol className="install-banner-steps">
              <li>Tap the <strong>Share</strong> button <span className="install-step-icon">⬆</span> in Safari's toolbar</li>
              <li>Scroll down and tap <strong>"Add to Home Screen"</strong></li>
              <li>Tap <strong>Add</strong> — done!</li>
            </ol>
          ) : (
            <ol className="install-banner-steps">
              <li>Tap the <strong>menu</strong> <span className="install-step-icon">⋮</span> in Chrome's top bar</li>
              <li>Tap <strong>"Add to Home screen"</strong> or <strong>"Install app"</strong></li>
              <li>Tap <strong>Add</strong> — done!</li>
            </ol>
          )}
          <button className="install-banner-done-btn" onClick={dismiss}>Got it</button>
        </div>
      )}
    </div>
  );
}

export default InstallBanner;
